/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Space,
  Button,
  Tooltip,
  Modal,
  message,
  TimePicker,
  Popconfirm,
  DatePicker,
  Input,
} from "antd";
import {
  capitaliseWithHyphen,
  serialNum,
  dateFormat_dmy,
  commonSorterForTable,
} from "../../../utils";
import { useNavigate, useLocation } from "react-router";
import check_out_img from "../../../assests/images/middleMile/check_out.svg";
import search_icon from "../../../assests/images/search-icon.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";

import { ReactComponent as Lock_icon } from "../../../assests/images/lock.svg";
import { ReactComponent as Unlock_icon } from "../../../assests/images/ulock.svg";
import { ReactComponent as Checkmark } from "../../../assests/images/checkmark.svg";

import urls from "../../../api/urls";
import API from "../../../api";
import "./style.scss";
import moment from "moment";
import {DeleteFilled, DownloadOutlined, } from "@ant-design/icons";
import ShipmentReportPdf from "../../../components/ShipmentReportPdf";
import { APIs } from "../../../utils/worker";
import { pdf } from "@react-pdf/renderer";



const TripList = (filterType) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    GET_ALL_LCR_TRIPS,
    POST_CHECKOUT_TIME,
    SEARCH_TRIP_LIST,
    LOCK_TRIP_LCR,
    EXIT_TRIP,
    REMOVE_EMPTY_LCR
  } = urls;
  const { RangePicker } = DatePicker;
  const [dataSource, setDataSource] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tripId, setTripId] = useState(null);
  const [vehicleNo, setVehicleNo] = useState(null);
  const [checkoutTime, setCheckoutTime] = useState("");
  // const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(1, "days").startOf("day").format("DD-MM-YYYY HH:mm"),
    endDate: moment().endOf("day").format("DD-MM-YYYY HH:mm")
  });
  const [sortedInfo, setSortedInfo] = useState({});
  const [totalCount,setTotalCount]=useState(0);
  const [vehicleLcrId,setVehicleLcrId]=useState();
  const tableLoading = {
    spinning: loading,
    indicator: (
      <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
    ),
  };
  
  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 5,
      render: (text, record, index) => {
        return (currentPage - 1) * pageSize + (index + 1);
      },
    },
    {
      title: "Vehicle/Flight LCR ID",
      dataIndex: "vehicleLcrId",
      key: "vehicleLcrId",
      width: 10,
      sorter: false,
      sortOrder: null,
      // render: (text) => <div>{text || "------"}</div>,
      render: (text, record) => (
        <span
          className="span-link"
          onClick={() =>
            navigate("/shipment-report", {   state: { 
              tripId: record?.tripId, 
              vehicleLcrStatus: record?.vehicleLcrStatus 
            } 
          })
          }>
          {text || "------"}
        </span>
      ),
    },
    {
      title: "Vehicle/Flight LCR Status",
      width: 10,

      dataIndex: "vehicleLcrStatus",
      key: "vehicleLcrStatus",
      sortOrder:
        sortedInfo.columnKey === "vehicleLcrStatus" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "vehicleLcrStatus"),
      ellipsis: true,
      render: (text) => <div>{text || "------"}</div>,
    },
    {
      title: "Mode",
      width: 7,

      dataIndex: "travelBy",
      key: "travelBy",
      sortOrder: sortedInfo.columnKey === "travelBy" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "travelBy"),
      ellipsis: true,
      render: (text) => <div>{capitaliseWithHyphen(text) || "------"}</div>,
    },
    {
      title: "Vehicle No.",
      width: 10,

      dataIndex: "",
      key: "",
      sorter: false,
      sortOrder: null,

      ellipsis: true,
      render: (text) => (
        <span>{text?.vehicleNum ? text?.vehicleNum : text?.flightNum}</span>
      ),
    },
    {
      title: "Outscan To.",
      width: 15,

      dataIndex: "",
      key: "",
      sorter: false,
      sortOrder: null,

      ellipsis: true,
      render: (text) => (
        <span>{text?.stopDestination}</span>
      ),
    },
    {
      title: "Bag Count",
      width: 10,

      dataIndex: "",
      key: "",
      sorter: false,
      sortOrder: null,

      ellipsis: true,
      render: (text) => (
        <span>{text?.bagCount}</span>
      ),
    },
    {
      title: "Route",
      width: 20,
      dataIndex: "routeName",
      key: "routeName",
      sortOrder: sortedInfo.columnKey === "routeName" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "travelBy"),
      ellipsis: true,
      render: (text) => (
        <span>{text ? capitaliseWithHyphen(text) : "------"}</span>
      ),
    },
    {
      title: "Co-loader",
      width: 8,
      dataIndex: "coloader",
      key: "coloader",
      sortOrder: sortedInfo.columnKey === "coloader" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "coloader"),
      ellipsis: true,
      render: (text) => <span>{text?.coloader ? text?.coloader : "NA"}</span>,
    },
    {
      title: "Driver Name",
      width: 10,
      dataIndex: "driverName",
      key: "driverName",
      sortOrder:
        sortedInfo.columnKey === "driverName" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "driverName"),
      ellipsis: true,
      render: (text) => (
        <span>{text ? capitaliseWithHyphen(text) : "------"}</span>
      ),
    },
    {
      title: "Created Date",
      width: 10,

      dataIndex: "createdDate",
      key: "createdDate",
      sortOrder:
        sortedInfo.columnKey === "createdDate" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "createdDate"),
      ellipsis: true,
      render: (text) => (
        <span>
          {`${text?.split(" ")[0]?.split("-")?.join("-")}` || "------"}
        </span>
      ),
    },
    {
      title: "Trip Status",
      width: 8,
      dataIndex: "status",
      sortOrder: sortedInfo.columnKey === "status" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "status"),
      ellipsis: true,
      key: "status",
      render: (text) => <div>{text || "------"}</div>,
    },
    
    {
      title: "Actions",
      width: 35,
      dataIndex: "",
      sorter: false,
      sortOrder: null,
      key: "",
      fixed: "right",
      ellipsis: true,
      render: (record, _record) => {
        const isDownloadDisabled =
          _record?.vehicleLcrStatus !== "LOCKED" ||
          (filterType?.filterType === "OUTGOING_HUBS" && _record?.status === "DISCARDED");
        return (
          <Space>
            {/* <Button
              className="cancel-btn"
              onClick={async () => {
                let response = await API.Api(
                  EXIT_TRIP + _record?.tripId
                ).putIdHeader();
              }}
            >
              Exit Trip
            </Button> */}
            <Button
              disabled={!_record?.isEwayBill || _record?.vehicleLcrStatus === "UNLOCKED"}
              className={`cancel-btn ${_record?.isEwayBill && _record?.isEwayBillUpdated ? "btn-green" : ""}`}
              onClick={() => {
                navigate(`/hub-eway-bill/${_record.tripId}`, {
                  state: { state: _record, slug: "/lcr-generation" },
                });
              }}>
              E-WAY BILL UPDATE
            </Button>
            <Button
              className="cancel-btn"
              disabled={!_record?.isEwayBill}
              onClick={() =>
                navigate("/print-eway-bill", {
                  state: {
                    state: _record?.tripId,
                    key: "VIEW_TRIP",
                    slug: "/lcr-generation",
                  },
                })
              }>
              PRINT
            </Button>
            {/* {filterType?.filterType === "OUTGOING_HUBS" && ( */}
              <Tooltip title={"Download LCR"}>
              <Button
                style={{
                  backgroundColor: isDownloadDisabled ? "#e9ecef" : "#2e77d0",
                  color: isDownloadDisabled ? "#8a8f94" : "white",
                  border: "none",
                  cursor: isDownloadDisabled ? "not-allowed" : "pointer"
                }}
                icon={<DownloadOutlined />}
                size="default"
                shape="circle"
                disabled={isDownloadDisabled}
                onClick={() => handleDownload(_record?.tripId)}
                />
            </Tooltip>
            {/* )} */}
            
            <div
              style={{ padding: "0 5px" }}
              className={
                _record?.status == "COMPLETED" || 
                _record?.vehicleLcrStatus === "UNLOCKED" || 
                (_record?.empty && _record?.status !== "DISCARDED") 
                  ? "pointer" 
                  : "disabled-div"
              }
              onClick={() =>!_record?.empty? lockUnlockLCR(_record?.tripId):removeEmptyLCR(_record?.tripId)}>
              <Tooltip
                title={_record?.status === "COMPLETED"?"":_record?.empty? "Remove Empty LCR":
                   _record?.vehicleLcrStatus === "LOCKED"
                    ? "UNLOCK"
                    : "LOCK"
                }>
                {_record?.status === "COMPLETED" ? (
                  <Checkmark width={25} height={25} />
                ) : _record?.empty ?<DeleteFilled style={{ color: _record?.status == "DISCARDED" ? "#d9d9d9" : "#f5222d",fontSize:"20px" }}/>:
                _record?.vehicleLcrStatus === "UNLOCKED" ? (
                  <Unlock_icon />
                ) : (
                  <Lock_icon />
                )}
              </Tooltip>
            </div>
            <Tooltip title={"CHECK-OUT"}>
              <div
                onClick={() => showModal(_record)}
                className={
                  record?.travelBy?.toUpperCase() === "AIR"
                    ? "disabled-div"
                    : "pointer"
                }>
                <img src={check_out_img} />
              </div>
            </Tooltip>
           
          </Space>
        );
      },
    },
  ];

  const lockUnlockLCR = async (id, lock) => {
    setLoading(true);
    let response = await API.Api(LOCK_TRIP_LCR + id).putIdHeader();
    if (response?.status) {
      setLoading(false);
      getTripList(dateRange?.startDate, dateRange?.endDate,vehicleLcrId);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };
  const removeEmptyLCR = async (id) => {
    setLoading(true);
    let response = await API.Api(REMOVE_EMPTY_LCR + id).putIdHeader();
    if (response?.status) {
      setLoading(false);
      getTripList(dateRange?.startDate, dateRange?.endDate,vehicleLcrId);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message);
    }
  };
  const showModal = (record) => {
    setIsModalOpen(true);
    setTripId(record?.tripId);
    setVehicleNo(record?.vehicleNum);
    // setBtnDisable(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  const getTodayAndYestardayDate = (startDate, endDate) => {
    if (!startDate || !endDate) return "";
    return `&fromDate=${startDate}&toDate=${endDate}`;
  };

  const getTripList = async (startDate, endDate, vehicleLcrId) => {
    setLoading(true);
    let urls = GET_ALL_LCR_TRIPS + `?pageNum=${currentPage - 1 || 0}&pageSize=${pageSize}&filterType=${filterType?.filterType}`;
    
    // Only add date parameters if there's no vehicleLcrId search
    if (!vehicleLcrId && startDate && endDate) {
      const dateParams = getTodayAndYestardayDate(startDate, endDate);
      console.log("Date params:", dateParams); // For debugging
      urls += dateParams;
    }
    
    if (vehicleLcrId) {
      urls += `&vehicleLcrId=${vehicleLcrId}`;
    }

    console.log("Final URL:", urls); // For debugging

    let response = await API.Api(urls).getWithUserNPremiseHeader();
    if (response?.status) {
      setLoading(false);
      setTotalCount(response?.response?.data?.count);
      let temp = response?.response?.data?.data.map((item, index) => ({
        ...item,
        key: index + 1,
      }));
      setDataSource(temp);
    } else {
      setLoading(false);
      message.error(response?.response?.data?.message || "Failed to fetch data");
    }
  };

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  function paginationHandle(currentPage, pageSize) {
    // if (dateRangeStatus) {
    //   dateSearchFun(currentPage, pageSize);
    // }
    setCurrentPage(currentPage);
    setPageSize(pageSize);
  }
  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const onTimeChange = (time, timeString) => {
    setCheckoutTime(timeString);
  };

  const handleOk = async () => {
    setLoading(true);
    let response = await API.Api(
      `${POST_CHECKOUT_TIME}check_out/${tripId}`
    ).postWithPrmiseHeader({
      vehicleNum: vehicleNo,
      checkOutTime: checkoutTime,
    });
    if (response?.status) {
      message.success("successfully checked out");
      setLoading(false);
      setIsModalOpen(false);
    } else {
      setLoading(false);
      setIsModalOpen(false);
      message.error(response?.response?.data?.message);
    }
  };

  const handleDateChange = (dates, dateStrings) => {
    setVehicleLcrId("");
    if (dates) {
      let [startDate, endDate] = dates;
      // If user only picked dates (not time), set to 00:00 and 23:59
      if (startDate && startDate.hour() === 0 && startDate.minute() === 0 && dateStrings[0].length <= 10) {
        startDate = startDate.startOf("day");
      }
      if (endDate && endDate.hour() === 0 && endDate.minute() === 0 && dateStrings[1].length <= 10) {
        endDate = endDate.endOf("day");
      }
      const formattedStartDate = startDate.format("DD-MM-YYYY HH:mm");
      const formattedEndDate = endDate.format("DD-MM-YYYY HH:mm");
      setDateRange({
        startDate: formattedStartDate,
        endDate: formattedEndDate
      });
      getTripList(formattedStartDate, formattedEndDate, "");
    } else {
      setDateRange({ startDate: "", endDate: "" });
      getTripList("", "", "");
    }
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };
  const onSearch = (e) => {
    const inputValue = e.target.value;
    setVehicleLcrId(inputValue);

    if (inputValue.length > 10 && inputValue.length < 15) {
      // Clear any existing date filter when searching by ID
      setDateRange({ startDate: "", endDate: "" });
      setCurrentPage(1);
      getTripList("", "", inputValue);
    } else if (inputValue.length === 0) {
      setCurrentPage(1);
      // When clearing search, set default two-day range and load data
      const startDate = moment().subtract(1, "days").startOf("day").format("DD-MM-YYYY HH:mm");
      const endDate = moment().endOf("day").format("DD-MM-YYYY HH:mm");
      setDateRange({
        startDate: startDate,
        endDate: endDate
      });
      getTripList(startDate, endDate, "");
    }
  };

  const didFetchRef = useRef(false);

  useEffect(() => {
    if (!didFetchRef.current) {
      didFetchRef.current = true;
      // Always use default date range
      const startDate = moment().subtract(1, "days").startOf("day").format("DD-MM-YYYY HH:mm");
      const endDate = moment().endOf("day").format("DD-MM-YYYY HH:mm");
      setDateRange({
        startDate: startDate,
        endDate: endDate
      });
      getTripList(startDate, endDate, "");
    }
  }, [filterType]); // Reset on tab change

  const handleDownload = async (tripId) => {

    let response = await API.Api(
      APIs.baseURL + "/lcr-service/web/v1/lcr/download/" + tripId
    ).getWithUserNPremiseHeader();
    if(response.response.data.length === 0){
       message.error("No data found");
       return;
    }
    if (response?.status) {
      const blob = await pdf(
        <ShipmentReportPdf masterData={response?.response?.data} />
      ).toBlob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);

      link.download = `LCR_Info_(${response?.response?.data[0].vehicleLcrId}).pdf`;
      link.click();
    } else {
      message.error(response?.response?.data?.message);
    }
  };
  return (
    <div className="bagging-shipment" style={{ padding: "0" }}>
      <div className="lcr-table-container">
        <div className="flex-end" style={{ padding: "0 10px 5px 10px" }}>
          <div className="center">
            <Input
              className="mr-1"
              placeholder="Enter Vehicle/Flight LCR to search"
              onChange={onSearch}
              value={vehicleLcrId || ""} // Handle null/undefined case
              allowClear // Add clear button
              bordered
              style={{
                borderRadius: "5px",
                height: "40px",
              }}
              suffix={<img src={search_icon} />}
            />
          </div>
          <RangePicker
            disabledDate={disabledDate}
            onChange={handleDateChange}
            format={"DD/MM/YYYY :HH:mm"}
            showTime={{ format: "HH:mm" }}
            defaultValue={[
              moment().subtract(1, "days").startOf("day"),
              moment().endOf("day")
            ]}
            value={dateRange.startDate && dateRange.endDate ? [
              moment(dateRange.startDate, "DD-MM-YYYY HH:mm"),
              moment(dateRange.endDate, "DD-MM-YYYY HH:mm")
            ] : null}
          />
        </div>
        <Table
          className="table-head-sticky"
          loading={tableLoading}
          columns={columns}
          dataSource={dataSource}
          rowClassName={(record) => (
            filterType?.filterType === "OUTGOING_HUBS" && record?.status === "DISCARDED"
              ? "disabled-div"
              : ""
          )}
          scroll={{
            x: 1800,
            y: 500,
          }}
          onChange={handleChange}
          pagination={{
            showSizeChanger: true, 
            pageSize: pageSize,
            itemRender: itemRender,
            total: totalCount,
            pageSizeOptions: [25,50,75,100,125,150],
            current: currentPage,
            onChange: paginationHandle,
          }}
        />
        <Modal
          className="timepicker-modal"
          title="Check-out"
          open={isModalOpen}
          maskClosable={false}
          footer={false}
          onCancel={handleCancel}
          destroyOnClose>
          <TimePicker onChange={onTimeChange} format={"HH:mm"} />
          <div className="flex-end mt-1">
            <Button onClick={handleCancel} className="cancel-btn mr-1">
              {"CANCEL"}
            </Button>
            <Popconfirm
              title="Do you wish to check-out"
              onConfirm={handleOk}
              okText="Yes"
              cancelText="No"
              style={{ background: "none" }}>
              <Button
                className="save-btn"
                // disabled={btnDisable}
              >
                {"SAVE"}
              </Button>
            </Popconfirm>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default TripList;
